/** @format */

import * as React from 'react';
//@ts-ignore
import { StyleSheet, View } from 'react-native';
//@ts-ignore
import { JDDevice, JDText } from '@jdreact/jdreact-core-lib';
//@ts-ignore
import LinearGradient from '@jdreact/jdreact-core-linear-gradient';

const { getRpx, getFontSize } = JDDevice;
const styles = StyleSheet.create({
  wrap: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  title: {
    height: getRpx(50),
    lineHeight: getRpx(50),
    fontSize: getRpx(36),
    fontWeight: 'bold',
    color: '#262626',
    zIndex: 1,
  },
  line: {
    width: '100%',
    position: 'absolute',
    left: getRpx(13),
    bottom: getRpx(4),
    height: getRpx(12),
  },
  linePlaceholder: {
    width: getRpx(9),
    height: getRpx(12),
    backgroundColor: '#fff',
    position: 'absolute',
    bottom: 0,
    right: 0,
  },
});
interface props {
  title: string;
  marginBottom: number;
}
interface state {}
export default class InfoTitle extends React.PureComponent<props, state> {
  constructor(props: props) {
    super(props);
  }
  render() {
    const { title, marginBottom = 0 } = this.props;
    return (
      <View style={[styles.wrap, { marginBottom: getRpx(marginBottom) }]}>
        <View>
          <LinearGradient
            colors={['rgba(255,212,99, 0.5)', 'rgba(255,209,29, 1)']}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 0 }}
            style={styles.line}
          >
            <View style={styles.linePlaceholder}></View>
          </LinearGradient>
          <JDText style={styles.title}>{title}</JDText>
        </View>
      </View>
    );
  }
}
